import type { IconSvgObject } from './types';

const Tree04Icon: IconSvgObject = [
  ["path", { d: "M12 22V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 17C7.2066 15.9626 6 14.2208 6 12C6 10.3744 6.95007 9.08055 8 8C8 8 7.5 7 7.5 6C7.5 3.5 9.5 2 12 2C14.5 2 16.5 3.5 16.5 6C16.5 7 16 8 16 8C17.0499 9.08055 18 10.3744 18 12C18 14.2208 16.7934 15.9626 15 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 15L14.5 12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 13L9.5 10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M10 22H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Tree04Icon;
